import {
  Directive,
  ElementRef
} from '@angular/core';

@Directive({
  selector: '[appSkillTooltip]'
})
export class SkillTooltipDirective {

  constructor(private el: ElementRef) {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/skill-tooltip.directive.ts